import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, Team, WhyUs, Process, NewsletterSection, Partners, DownloadApp, HomeBooking, Features, CaseSection, TaxiSlider } from '../../sections';
import { Banner } from '../../components';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Hero section with a call-to-action */}
      <HomeBooking /> {/* HomePage Taxi booking Form */}
      <Features /> {/* Key features of the service */}
      <About /> {/* Company Information */}
      <Counter /> {/* Important statistics and achievements */}
      <Services /> {/* List of available services */}
      <WhyUs /> {/* Reasons to choose our service */}
      <Process /> {/* Step-by-step process explanation */}
      <Banner /> {/* Banner Component */}
      <CaseSection /> {/* Showcase of Case Studies */}
      <Testimonials /> {/* Customer reviews and feedback */}
      <Team /> {/* Meet the team members */}
      <DownloadApp /> {/* App download section with store links */}
      <TaxiSlider /> {/* Interactive taxi booking slider */}
      <NewsletterSection /> {/* Newsletter subscription form */}
      <Blogs /> {/* Latest blog posts and industry insights */}
      <Partners /> {/* Business partners and affiliations */}
    </div>

  )
}

export default HomePage;